document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function checkVisibility() {
        const elements = document.querySelectorAll('.scroll-animation');
        const bottomOfScreen = window.scrollY + window.innerHeight - 200;
        const topOfScreen = window.scrollY;

        elements.forEach(function(element) {
            const topOfElement = element.getBoundingClientRect().top + window.scrollY;
            const bottomOfElement = topOfElement + element.offsetHeight;

            if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement && !element.classList.contains('is-visible')) {
                element.classList.add('is-visible');
            }
        });
    }

    setTimeout(checkVisibility, 2000);

    window.addEventListener('scroll', checkVisibility);

    const flyouts = document.querySelectorAll('.flyout-wrapper');
    flyouts.forEach(flyout => {
        const observer = new MutationObserver(() => {
            checkVisibility();
        });
        observer.observe(flyout, { attributes: true, attributeFilter: ['class'] });
    });

    /*
     * Background videos. Lazy ones (data-lazy-video, preload="none", source in data-src) get their source
     * once they come within 300px of the viewport, and every video only plays while it's on screen.
     * Videos in a closed flyout are display: none and never intersect, so they aren't loaded until opened.
     */
    function loadVideo(video) {
        if (!video.hasAttribute('data-lazy-video')) {
            return;
        }
        video.removeAttribute('data-lazy-video');
        video.querySelectorAll('source[data-src]').forEach(function (source) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
        });
        video.load();
    }

    function playVideo(video) {
        loadVideo(video);
        // play() rejects with AbortError when pause() interrupts it (e.g. fast scrolling) — harmless
        const playing = video.play();
        if (playing) {
            playing.catch(function (error) {
                if (error.name !== 'AbortError') {
                    console.warn(error);
                }
            });
        }
    }

    const loader = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                loadVideo(entry.target);
                loader.unobserve(entry.target);
            }
        });
    }, { rootMargin: '300px 0px' });

    const player = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                if (entry.target.paused) {
                    playVideo(entry.target);
                }
            } else if (!entry.target.paused) {
                entry.target.pause();
            }
        });
    });

    function observeVideos(root) {
        const videos = root.matches && root.matches('video') ? [root] : root.querySelectorAll('video');
        videos.forEach(function (video) {
            if (video.hasAttribute('data-lazy-video')) {
                loader.observe(video);
            }
            player.observe(video);
        });
    }

    // Start after the load event so videos above the fold don't compete with the page's own resources
    function startVideos() {
        observeVideos(document);

        // Cards added later (load more, filters) render their videos client side
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        observeVideos(node);
                    }
                });
            });
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'complete') {
        startVideos();
    } else {
        window.addEventListener('load', startVideos);
    }
});

//# sourceMappingURL=above-the-fold.js.map
